import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-accent-50 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            探索更多精彩内容
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            按分类浏览您感兴趣的内容，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category?tab=${category.slug}`}
              className="bg-background-50 rounded-lg p-5 hover:bg-accent-50/50 transition-colors group flex items-start gap-4"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md bg-accent-50 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-700 transition-colors">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                  {category.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {category.articleCount} 篇文章
                </span>
              </div>
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-300 group-hover:text-accent-500 transition-colors ml-auto">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}